<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:MessageDialog
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/06 | 富士通株式会社         | 新規作成
// 01.01.00 | 2024/03/29 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
// 01.02.00 | 2024/09/17 | 富士通Japan株式会社    | 令和6年度改修対応（1次リリース）
//================================================================================
-->
<template>
	<div
		class="modal"
		@keydown.esc="cancel"
		@keydown.prevent.tab.exact="moveFirst()"
		@keydown.prevent.shift.tab.exact="moveLast()"
	>
		<div class="modal__bg" />
		<div class="modal__contents-confirm">
			<!-- 通知用アイコン表示 -->
			<div
				v-if="isNoticeFlg"
				class="modal__header"
			>
				<font-awesome-icon
					icon="check-circle"
					size="3x"
					class="modal__header--icon-notice"
				/>
			</div>
			<!-- 確認用アイコン表示 -->
			<div
				v-if="isConfirmFlg"
				class="modal__header"
			>
				<font-awesome-icon
					icon="info-circle"
					size="3x"
					class="modal__header--icon-confirm"
				/>
			</div>
			<!-- 警告用アイコン表示 -->
			<div
				v-if="isAlertFlg"
				class="modal__header"
			>
				<font-awesome-icon
					icon="exclamation-triangle"
					size="3x"
					class="modal__header--icon-alert"
				/>
			</div>
			<div v-if="isLinkFlg" class="modal__body">
				<p class="modal__body--message"
					v-html="message">
				</p>
			</div>
			<div v-else class="modal__body">
				<p class="modal__body--message">
					{{ message }}
				</p>
			</div>
			<div class="modal__footer">
				<button
					v-for="(item, index) in items"
					:ref="'refs_' + index"
					:key="item.key"
					type="button"
					:class="[index == 0 ? 'contents__btn--confirm' : 'contents__btn--cancel'
									, index == 0 && items.length > 1 ? 'modal__footer-btn-margin' : '']"
					:tabindex="'0'"
					@keydown.prevent.tab.exact.stop="moveNext(item.key)"
					@keydown.prevent.shift.tab.exact.stop="movePrev(item.key)"
					@click="clickButton(item.key)"
				>
					{{ item.val }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { STORE_DIALOG_DIALOG_FLG, STORE_DIALOG_GET_CALL_BACK, STORE_DIALOG_GET_KIND, STORE_DIALOG_IS_LINK_FLG } from '@/const/store.js';
import { DIALOG_BUTTON_LIST_KEY, DIALOG_KIND } from '@/const/const.js';

export default {
	props: {
		message: {type: String, default: ''},		// ダイアログに出力するメッセージ
		buttonList: {type: Array, default: function() {
				return []
			}
		},											// ダイアログに設定するボタンのリスト
		focusKey: {type: String, default: ''},		// フォーカスの設定するボタンのキー
	},
	data: function() {
		return {
			items: []
		}
	},
	computed: {
		isNoticeFlg: function () {
			return this.$store.getters[STORE_DIALOG_GET_KIND] === DIALOG_KIND.NOTICE ? true : false;
		},
		isConfirmFlg: function () {
			return this.$store.getters[STORE_DIALOG_GET_KIND] === DIALOG_KIND.CONFIRM ? true : false;
		},
		isAlertFlg: function () {
			return this.$store.getters[STORE_DIALOG_GET_KIND] === DIALOG_KIND.ALERT ? true : false;
		},
		isLinkFlg: function () {
			return this.$store.getters[STORE_DIALOG_IS_LINK_FLG];
		}
	},
	created: function() {

		// リスト追加
		let list = [];
		for ( let i = 0; i < this.buttonList.length; i++ ) {
			list.push({key: this.buttonList[i].key, val: this.buttonList[i].label});
		}

		this.items = list;

	},
	mounted: function() {
		// ボタンのフォーカス設定
		this.focus(this.getKeyIndex(this.focusKey));
	},
	beforeUnmount() {
		this.items = null;
	},
	methods: {
		moveFirst: function () {
			this.focus(0);
		},
		moveLast: function () {
			this.focus(this.items.length - 1);
		},
		moveNext: function ( key ) {
			let index = this.getKeyIndex(key);
			index = index + 1;

			if ( this.items[index] === undefined ) {
				index = 0;
			}

			this.focus(index);
		},
		movePrev: function ( key ) {
			let index = this.getKeyIndex(key);
			index = index - 1;

			if ( this.items[index] === undefined ) {
				index = this.items.length - 1;
			}

			this.focus(index);
		},
		// キーに対応した配列の要素を取得
		getKeyIndex: function ( key ) {
			for ( let i = 0; i < this.buttonList.length; i++ ) {
				if( this.buttonList[i].key === key ) {
					return i;
				}
			}
			return -1;
		},
		// フォーカス設定
		focus: function( index ) {
			if (this.$refs['refs_' + index] !== undefined) {
				this.$refs['refs_' + index][0].focus();
			}
		},
		clickButton: function(val) {
			// メッセージウィンドウを閉じる
            this.$store.commit(STORE_DIALOG_DIALOG_FLG, false);
			// コールバック関数の呼び出し
			this.$store.getters[STORE_DIALOG_GET_CALL_BACK](val);
		},
		cancel: function () {
			// ESC押下時のキーイベント
			// メッセージウィンドウを閉じる
            this.$store.commit(STORE_DIALOG_DIALOG_FLG, false);
			// コールバック関数の呼び出し
			this.$store.getters[STORE_DIALOG_GET_CALL_BACK](DIALOG_BUTTON_LIST_KEY.ESC);
		}
	}
}
</script>

<style scoped>
.modal {
	z-index: 100001;
}
</style>